import type { TPersonalType } from "@/types"
import { shirtSizes } from "@/utils/constants"
import { MultiAnswerDate } from "./MultiAnswerDate"
import { MultiAnswerChoices } from "./MultiAnswerSingle"
import type { IMultiAnswerProps } from "./types"

export function MultiAnswerPersonal(props: IMultiAnswerProps) {
  const { question } = props
  const category = question.meta.category as TPersonalType

  if (category == "birthday" || category == "start_date") return <MultiAnswerDate {...props} />
  if (category == "size")
    return <MultiAnswerChoices {...props} choices={shirtSizes.map((size, idx) => ({ value: idx, label: size }))} />

  // TODO: city, manager
  return null
}
